"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NotificationItem = _interopRequireDefault(require("./NotificationItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notifications = function Notifications(_ref) {
  var data = _ref.data,
      onReadNotification = _ref.onReadNotification,
      errorMessage = _ref.errorMessage,
      emptyMessage = _ref.emptyMessage;

  if (errorMessage) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "NotificationsError"
    }, errorMessage);
  }

  if (!Array.isArray(data) || data.length === 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "NotificationsError"
    }, emptyMessage);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Notifications"
  }, data.map(function (_ref2) {
    var id = _ref2.id,
        date = _ref2.date,
        subject = _ref2.subject,
        text = _ref2.text;
    return /*#__PURE__*/_react.default.createElement(_NotificationItem.default, {
      onClick: onReadNotification,
      key: id,
      id: id,
      date: date,
      subject: subject,
      text: text
    });
  }));
};

Notifications.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    subject: _propTypes.default.string,
    date: _propTypes.default.string,
    text: _propTypes.default.string
  })),
  onReadNotification: _propTypes.default.func,
  errorMessage: _propTypes.default.string,
  emptyMessage: _propTypes.default.string
};
Notifications.defaultProps = {
  data: [],
  onReadNotification: function onReadNotification() {},
  errorMessage: null,
  emptyMessage: null
};
var _default = Notifications;
exports.default = _default;